<script>

/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
import ProductItem from './product-item'

export default {
  name: 'product-list-selecetd-item',
  props: ['item'],
  methods: {
    removeItem: function () {
      this.$store.dispatch('sale/removeProduct',this.item);
    },
    expandItem: function () {
      this.$store.dispatch('sale/expandProduct',this.item);
    },
    setProductSelected(){
      this.$store.dispatch('sale/setProductSelected',this.item);
    }
  },
  mounted: function () {
  },
  computed: {
    itemCost: function () {
      return (this.item.cost - this.item.discount * this.item.cost / 100) * this.item.amount;
    }
  }
}
</script>
<template>
<div class="product-item">
    <i class="bx bx-x remove-btn" @click="removeItem(item)"></i>
    <div class="item-name">
        <strong>{{item.name}}</strong>
        <!-- <p class="cost-price">Giá bán: <b>{{ item.cost | VND }} <sup>₫</sup></b> <span style="padding: 0px 4px">|</span> Số lượng: <b>{{item.amount | VND }}</b> <span class="btn-expand" v-if="item.amount > 1" @click="expandItem()"> <i class="bx bx-expand"></i></span></p> -->
        <p class="cost-price">Giá bán: <b>{{ item.cost | VND }} <sup>₫</sup></b> <span style="padding: 0px 4px">|</span>
          Serial: <b>{{item.serials.join(", ")}}</b> <span class="btn-expand" v-if="item.amount > 1" @click="expandItem()"> <i class="bx bx-expand"></i></span></p>
        <div class="list-serial">{{item.serials.join(", ")}}</div>
    </div>
    <div class="item-cost">
        <div class="item-price" @click="setProductSelected" v-b-modal.modal-discount>{{ itemCost | VND }}  <sup>₫</sup><i class="bx bxs-purchase-tag-alt" ></i></div>
        <span v-if="item.discount > 0"  style="font-size: 0.9em;font-weight: normal;"> Chiết khấu {{item.discount}}%</span>
    </div>    
</div>
</template>